import { LOGOUT } from "@/components/access/ducks/Actions"
import { RECEIVE_CAREER_STATS } from "@/components/data/ducks/Actions"

const defaultState = {
  positionStats: [],
  industryStats: [],
  stateStats: [],
  continentStats: [],
}

const mapsReducer = (oldState = defaultState, action) => {
  Object.freeze(oldState)
  switch (action.type) {
    case LOGOUT:
      return defaultState

    case RECEIVE_CAREER_STATS:
      return {
        ...oldState,
        ...action.stats,
      }
    default:
      return oldState
  }
}

export default mapsReducer
